<div class="page-header-outer">
    <div class="page-header mapping">
        <h1 [ngClass]="{'no-errors': unmappedItemCount == 0 } ">{{entityName}} Mapping</h1>
        <div *ngIf="unmappedItemCount" class="unmapped-warning" (click)="toggleUnmappedOnly()">You have {{ unmappedItemCount }} unmapped {{ entityName }}{{ unmappedItemCount > 1 ? 's' : ''}}.</div>
    </div>
</div>
<div class="content-inner">
    <div class="admin-main" [ngClass]="{'loading': initialLoading || mobileLoading }" >
        <div>
            <div class="admin-list" [ngClass]="{'loading': adminListLoading }"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="scrollThrottle"
                [fromRoot]="false"
                [scrollWindow]="false"
                [infiniteScrollContainer]="scrollSelector"
                (scrolled)="onScrollDown()">
                <div class="filter-sort">
                    <div class="filter">
                        <input class="compact magic-filter" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by {{searchByText}}">
                    </div>
                    <div class="sort">
                        <label class="compact">Sort</label>
                        <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                            <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                                {{type}}
                            </option>
                        </select>
                        <a class="arrow compact" (click)="onChangeSortOrder()"
                            [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
                    </div>
                </div>
                <ul class="adminListScroll" >
                    <li *ngFor="let mapping of mappings" [value]="mapping.id" (click)="onSelection(mapping)" [ngClass]="{'active': getIsActive(mapping) }">
                        <ul class="unmapped">
                            <li class="active">
                                <div *ngIf="!mapping.isMapped">
                                    <span class="icon-notification"></span> Unmapped
                                </div>
                            </li>
                        </ul>
                        <div class="title">{{ getDisplayName(mapping) }}</div>
                        <ul class="details">
                            <ng-container [ngTemplateOutlet]="mappingDetailTemplate" [ngTemplateOutletContext]="{ $implicit: mapping }"></ng-container>
                            <li class="modified">
                                <span class="label">Last Modified</span>
                                <span class="value">{{ mapping.isMapped ? ( mapping.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') : "&nbsp;"  }}</span>
                            </li>
                            <li class="modified">
                                <span class="label">Last Modified By</span>
                                <span class="value">{{ mapping.isMapped ? mapping.modifiedByUserName : "&nbsp;"  }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }">
                <div class="admin-action suppress-scroll" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
                    <div class="header">
                        <div class="title">
                            {{ adminActionLabelText }}
                            <a class="close" href="javascript:void(0)" (click)="onCancel()"><span class="icon-cross"></span></a>
                        </div>
                    </div>
                    <section *ngIf="selection">
                        <ng-content select="[mappingFormBody]"></ng-content>
                        <div class="footer">
                            <button class="primary" type="submit" [disabled]="isSaveButtonDisabled()" (click)="onSave()">
                                <span class="icon-plus"></span> Save
                            </button>
                            <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                                <span class="icon-cancel"></span> Cancel</button>
                            <div class="error-message">
                                <label class="errormsg">{{ getErrorMessage() }}</label>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>
